const STORAGE_KEY = 'pending_device_link'

/** Legge ?deviceLink= dall'URL e pulisce la query string. */
export function consumeDeviceLinkFromUrl(): string | null {
  const sid = new URLSearchParams(location.search).get('deviceLink')?.trim()
  if (!sid) return null
  try {
    history.replaceState({}, '', location.pathname + location.hash)
  } catch {
    /* ignore */
  }
  return sid
}

export function stashPendingDeviceLink(sessionId: string): void {
  sessionStorage.setItem(STORAGE_KEY, sessionId.trim())
}

export function takePendingDeviceLink(): string | null {
  const sid = sessionStorage.getItem(STORAGE_KEY)?.trim()
  if (sid) sessionStorage.removeItem(STORAGE_KEY)
  return sid || null
}

/** URL scan o sessione salvata in attesa di sblocco. */
export function resolvePendingDeviceLink(): string | null {
  return consumeDeviceLinkFromUrl() || takePendingDeviceLink()
}
